<template>
  <!-- ---------------------------------- 加入我们 ---------------------------------- -->
  <div class="join">
    <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
    <Header></Header>
    <!-- ---------------------------------- 海报图 ---------------------------------- -->
    <div class="banner">
      <p>共创·共享·共利</p>
    </div>
    <!-- ---------------------------------- 为什么选择蔚诺 ---------------------------------- -->
    <div class="choose">
      <!-- 标题 -->
      <div class="title">
        <img src="../assets/images/icon/join-illustrations.png" alt="">
        <p>为什么选择蔚诺？</p>
      </div>
      <!-- 内容 -->
      <div class="choose_main">
        <!-- 行业优势 -->
        <div class="choose_box">
          <!-- 插图 -->
          <img src="../assets/images/icon/why1.png" alt="">
          <h6>行业优势</h6>
          <p>室内空气净化、绿化、<br>减排、环保、养生、健康的<br>行业发展空间巨大</p>
        </div>
        <!-- 设备及技术优势 -->
        <div class="choose_box">
          <!-- 插图 -->
          <img src="../assets/images/icon/why2.png" alt="">
          <h6>设备及技术优势</h6>
          <p>领先的产品体验、<br>独家专利技术、稳定技术<br>保障、持续更新</p>
        </div>
        <!-- 服务优势 -->
        <div class="choose_box">
          <!-- 插图 -->
          <img src="../assets/images/icon/why3.png" alt="">
          <h6>服务优势</h6>
          <p>集团拥有多年服务理念及<br>文化的积累及沉淀、客户服<br>务经验丰富, 想客人所想,<br>急客人所急</p>
        </div>
      </div>
      <!-- 内容 -->
      <div class="choose_main">
        <!-- 培训优势 -->
        <div class="choose_box">
          <!-- 插图 -->
          <img src="../assets/images/icon/why4.png" alt="">
          <h6>培训优势</h6>
          <p>专业管理团队全程培训<br>指导、合伙人成长帮扶、<br>市场开发扶持</p>
        </div>
        <!-- 售后优势 -->
        <div class="choose_box">
          <!-- 插图 -->
          <img src="../assets/images/icon/why5.png" alt="">
          <h6>售后优势</h6>
          <p>定期回访总结及经验分享、<br>利润分析、营销广告及<br>活动支持、推广渠道共享、<br>区域保护支持、物流支持</p>
        </div>
        <!-- 创富优势 -->
        <div class="choose_box">
          <!-- 插图 -->
          <img src="../assets/images/icon/why6.png" alt="">
          <h6>创富优势</h6>
          <p>3种不同合作模式<br>(1.顶级分销商 2.一级分<br>销商 3.企业代理商)<br>适合不同规模企业、<br>合作模式简易、<br>创富同时创善!</p>
        </div>
      </div>
      <!-- 了解更多 -->
      <div class="more">
        <p @click="toAbout()">了解蔚诺更多</p>
        <img @click="toAbout()" src="../assets/images/icon/play-orange.png" alt="">
      </div>
    </div>
    <!-- ---------------------------------- 流程 ---------------------------------- -->
    <div class="process">
      <!-- ----------- 加盟商流程 ----------- -->
      <!-- 标题 -->
      <div class="title">
        <img src="../assets/images/icon/join-illustrations.png" alt="">
        <p>成为一级或以上分销商流程</p>
      </div>
      <!-- 流程 -->
      <p class="process_main">
        <span>(1)</span> 申请合作<span> > (2) </span>意向衔接<span> > (3) </span>企业资质、经营场所、<br>
        资金及实力等条件评估<span> > (4) </span>长期分销商合同<span> > (5) </span>人员、系统及产品培训<span> ></span><br>
        <span>(6) </span>培训考核<span> > (7) </span>订货及产品配送<span> > (8) </span>开幕
      </p>
      <!-- 点线 -->
      <div class="point_line"></div>
      <!-- ----------- 代理商流程 ----------- -->
      <!-- 标题 -->
      <div class="title">
        <img src="../assets/images/icon/join-illustrations.png" alt="">
        <p>成为二级分销商流程</p>
      </div>
      <!-- 流程 -->
      <p class="process_main">
        <span>(1)</span> 申请合作<span> > (2) </span>意向衔接<span> > (3) </span>企业资质评估<span> > </span><br>
        <span>(4)</span> 二级分销商合同<span> > (5) </span>获得代理授权<span> > (6) </span>人员、系统及产品培训<span> > </span><br>
        <span>(7)</span> 培训考核<span> > (8) </span>开幕
      </p>
      <!-- 点线 -->
      <div class="point_line"></div>
      <!-- ----------- 产品应用场景 ----------- -->
      <!-- 标题 -->
      <div class="title">
        <img src="../assets/images/icon/join-illustrations.png" alt="">
        <p>产品应用场景</p>
      </div>
      <!-- 场景一 -->
      <div class="scenario scenario_one">
        <!-- 家居 -->
        <div class="scenario_box">
          <p>家居</p>
        </div>
        <!-- 办公室 -->
        <div class="scenario_box">
          <p>办公室</p>
        </div>
        <!-- 学校 -->
        <div class="scenario_box">
          <p>学校</p>
        </div>
        <!-- 工厂 -->
        <div class="scenario_box">
          <p>工厂</p>
        </div>
      </div>
      <!-- 场景二 -->
      <div class="scenario scenario_two">
        <!-- 酒店 -->
        <div class="scenario_box">
          <p>酒店</p>
        </div>
        <!-- 政府及公营机构 -->
        <div class="scenario_box">
          <p>政府及<br>公营机构</p>
        </div>
        <!-- 各种休闲及娱乐场所 -->
        <div class="scenario_box">
          <p>各种休闲及<br>娱乐场所</p>
        </div>
      </div>
    </div>
    <!-- ---------------------------------- 加盟条件及费用 ---------------------------------- -->
    <div class="form">
      <!-- 标题 -->
      <div class="title">
        <img src="../assets/images/icon/join-illustrations.png" alt="">
        <p>分销商条件及费用</p>
      </div>
      <!-- 表格 -->
      <div class="form_main">
        <!-- 表格标题 -->
        <p>请留下个人联系方式</p>
        <!-- 联络人 -->
        <div class="input_box">
          <div>联络人</div>
          <input v-model="contract" type="text">
        </div>
        <!-- 请选择省份 -->
        <div class="input_box">
          <div>省份</div>
          <el-select v-model="province" class="options" placeholder="" @change="getCity">
            <el-option v-for="(item, index) in provinceList" :label="item.provinceCn" :value="item.id" :key="index">
              {{ item.provinceCn }}
            </el-option>
          </el-select>
        </div>

        <!-- 请选择省份 -->
        <div class="input_box">
          <div>城市</div>
          <el-select v-model="city" class="options" placeholder="">
            <el-option v-for="(item, index) in cityList" :value="item.id" :label="item.cityCn" :key="index">
              {{ item.cityCn }}
            </el-option>
          </el-select>
        </div>

        <!-- 电话 -->
        <div class="input_box">
          <div>电话</div>
          <input type="text" v-model="phone" @blur="phoneRule">
        </div>
        <!-- 电子邮件 -->
        <div class="input_box">
          <div>电子邮件</div>
          <input type="text" v-model="email" @blur="emailRule">
        </div>
        <!-- 提交按钮 -->
        <div class="confirm"> <div class="submit" @click="submit()">提交</div></div>
      </div>
    </div>
    <!-- ---------------------------------- 底部栏 ---------------------------------- -->
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer';
  import Axios from "axios";
  export default {
    components:{
      Header,
      Footer,
    },
    data() {
      return {
        contract:undefined,
        province:undefined,
        city:undefined,
        phoneR: false,
        emailR: false,
        phone:undefined,
        email:undefined,
        provinceList:[],
        cityList:[]
      }
    },
    mounted() {
      this.getshengfen();
    },
    methods: {
      // 获取省份
      getshengfen() {
        Axios.get(`${this.api.ip}/jeecg-boot/h5/h5Controller/getWyProvince`).then(res => {
          if (res.data.success == true) {
            this.provinceList = res.data.result
          }
        })
      },
      // 获取城市
      getCity() {
        var that = this
        that.city = undefined
        Axios.get(`${this.api.ip}/jeecg-boot/h5/h5Controller/getWyCity?provinceId=${this.province}`).then(res => {
          if (res.data.success == true) {
            this.cityList = res.data.result
          }
        })
      },
      phoneRule() {
        var that = this;
        if (that.phone.toString().length === 0){
          that.phoneR = false
          return
        }
        let rule = /^1[3456789]\d{9}$/;
        if (!rule.test(that.phone)){
          this.$message.error("请输入正确的电话！",1)
        }else {
          that.phoneR = true
        }
      },
      emailRule() {
        var that = this;
        if (that.email.toString().length === 0){
          that.emailR = false
          return
        }
        let rule = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if (!rule.test(that.email)){
          this.$message.error("请输入正确的电子邮箱！",1)
        }else {
          that.emailR = true
        }
      },
      // 跳转关于我们
      toAbout(){
        this.$router.push({
          path: '/about'
        })
      },
      submit(){
        if(!this.contract){
          this.$message.warn("请输入联络人",1)
          return
        }
        if(!this.province){
          this.$message.warn("请输入省份",1)
          return
        }
        if(!this.city){
          this.$message.warn("请输入城市",1)
          return
        }
        if(!this.phone){
          this.$message.warn("请输入电话",1)
          return
        }
        if (this.phoneR === false){
          this.$message.error("请输入正确的电话！",1)
          return false
        }
        if(!this.email){
          this.$message.warn("请输入电子邮件",1)
          return
        }
        if (this.emailR === false){
          this.$message.error("请输入正确的电子邮箱！",1)
          return false
        }
        var data = {
          contract:this.contract,
          province:this.province,
          city:this.city,
          phone:this.phone,
          email:this.email
        }
        var url =  "http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/addLeague";
        Axios.post(url,data).then(res => {
          if(res.data.success == true){
            this.$message.success("提交成功",1)
            this.$nextTick(()=>{
              this.contract = undefined
              this.province = undefined
              this.city = undefined
              this.phone = undefined
              this.email = undefined
            })
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .el-select__caret{
    font-size: 22px !important;
    color: #183075 !important;
  }
  /deep/ .el-input__suffix {
    right: 0.126042rem !important;
  }

  // ---------------------------- 海报图 ---------------------------------
  // ------------- mobile端样式 -------------
  @media only screen and (max-width: 960px) {     // 屏幕小于960px
    .banner{
      p{ font-size: 90px;position: absolute;bottom: 37%;right: 6%;}
    }
    // 标题
    .title{
      img{ width: 140px;height: 140px;}
      p{ font-size: 58px;line-height: 68px; font-family: "微软雅黑";}
    }
    // 内容
    .choose_main{
      width: 95%;
      .choose_box{
        img{ width: 186px;}
        h6{ font-size: 50px;}
        p{ font-size: 46px;}
      }
    }
    // 了解更多
    .more{
      p{ font-size: 62px;}
      img{ width: 76px;}
    }

    /deep/ .el-input{
      input{
        height: 100%;
      }
    }
	}
  // ------------- pc端样式 -------------
  @media only screen and (min-width: 960px) {     // 屏幕大于960px
    .banner{
      p{ font-size: 70px;font-weight: lighter;position: absolute;bottom: 37%;right: 12%;}
    }
    // 标题
    .title{
      img{ width: 110px;height: 110px;}
      p{ font-size: 42px;   font-family: "微软雅黑";}
    }
    // 内容
    .choose_main{
      width: 68%;
      .choose_box{
        img{ width: 106px;}
        h6{ font-size: 28px;}
        p{ font-size: 26px;}
      }
    }
    // 了解更多
    .more{
      p{ font-size: 32px;}
      img{ width: 56px;}
    }
	}
  .banner{
    width: 100%;
    height: 687px;
    background: url('../assets/images/join-banner.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
    position: relative;
    p{
      color: #FFFFFF;
      letter-spacing: 10px;
      margin: 0;
    }
  }
  // 标题
  .title{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-bottom: 70px;
	font-weight: bold;
	font-family: "微软雅黑";
    p{
      color: #00288E;
      letter-spacing: 5px;
      margin: 0;
      margin-left: -1em;
    }
  }
  .choose{
    width: 100%;
    background-color: #D5E5EB;
    padding: 72px 0 114px 0;
    // 内容
    .choose_main{
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      margin-bottom: 36px;
      .choose_box{
        text-align: center;
        color: #183075;
        letter-spacing: 2px;
        // 插图
        img{
          display: block;
          margin: 0 auto;
          margin-bottom: 30px;
        }
        h6{
          font-weight: bold;
          margin: 0 0 20px 0;
          color: #183075;
        }
        p{
          margin: 0;
          line-height: 1.6;
        }
      }
    }
    // 了解更多
    .more{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 20px;
      p{
        color: #F0844B;
        font-weight: bold;
        letter-spacing: 5px;
        margin: 0;
        cursor: pointer;
      }
      img{
        margin-left: 23px;
        cursor: pointer;
      }
    }
  }
  // ---------------------------- 加盟商流程 ---------------------------------
  // ------------- mobile端样式 -------------
  @media only screen and (max-width: 960px) {     // 屏幕小于960px
    // 流程
    .process_main{ font-size: 48px;}
    // 点线
    .point_line{ width: 55%;border-bottom: 8px dotted #F0844A;}
    // 场景
    .scenario_box{ width: 305px;height: 305px;border-radius: 200px 200px 200px 0;
      p{ font-size: 64px;}
    }
    // 场景二
    .scenario_two{
      .scenario_box:nth-child(2){
        p{ font-size: 50px;}
      }
      .scenario_box:nth-child(3){
        p{ font-size: 50px;}
      }
    }
	}
  // ------------- pc端样式 -------------
  @media only screen and (min-width: 960px) {     // 屏幕大于960px
    // 流程
    .process_main{ font-size: 28px;}
    // 点线
    .point_line{ width: 35%;border-bottom: 6px dotted #F0844A;}
    // 场景
    .scenario_box{ width: 205px;height: 205px;border-radius: 100px 100px 100px 0;
      p{ font-size: 40px;}
    }
    // 场景二
    .scenario_two{
      .scenario_box:nth-child(2){
        p{ font-size: 28px;}
      }
      .scenario_box:nth-child(3){
        p{ font-size: 28px;}
      }
    }
	}
  .process{
    width: 100%;
    background-color: #ffffff;
    padding: 81px 0 84px 0;
    // 流程
    .process_main{
      color: #183075;
      letter-spacing: 2px;
      text-align: center;
      line-height: 2;
      margin: 0;
      span{
        color: #F0844A;
        font-weight: bold;
      }
    }
    // 点线
    .point_line{
      margin: 80px auto;
    }
    // 场景
    .scenario{
      width: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      margin-bottom: 67px;
      // 场景
      .scenario_box{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 37px 0 37px;
        p{
          color: #00288E;
          letter-spacing: 2px;
          text-align: center;
          margin: 0;
        }
      }

    }
    // 场景一
    .scenario_one{
      // 背景颜色
      .scenario_box:nth-child(1){
        background-color: #CAE9FA;
      }
      .scenario_box:nth-child(2){
        background-color: #F4D1E0;
      }
      .scenario_box:nth-child(3){
        background-color: #D6D9AE;
      }
      .scenario_box:nth-child(4){
        background-color: #C9C3E0;
      }
    }
    // 场景二
    .scenario_two{
      // 背景颜色
      .scenario_box:nth-child(1){
        background-color: #FFF5C3;
      }
      .scenario_box:nth-child(2){
        background-color: #FAD8C9;
      }
      .scenario_box:nth-child(3){
        background-color: #CCE6D1;
      }
    }
  }
  
  // ---------------------------- 表格 ---------------------------------
  // ------------- mobile端样式 -------------
  @media only screen and (max-width: 960px) {     // 屏幕小于960px
    // 表格
    .form_main{
      width: 85%;
      // 表格标题
      p{ font-size: 48px;}
      // 输入框
      .input_box{ height: 98px;
        div{ font-size: 48px;width: 25%;}
        input{ font-size: 46px !important;}
      }
      // 提交按钮
      .confirm{ display: flex;justify-content: flex-start;}
      .submit{ width: 240px;font-size: 46px;}
    }
	}
  // ------------- pc端样式 -------------
  @media only screen and (min-width: 960px) {     // 屏幕大于960px
    // 表格
    .form_main{
      width: 1150px;
      // 表格标题
      p{ font-size: 28px;}
      // 输入框
      .input_box{ height: 68px;
        div{ font-size: 28px;width: 20%;}
        input{ font-size: 26px !important;}
      }
      // 提交按钮
      .confirm{ text-align: center;}
      .submit{ width: 170px;font-size: 26px;margin: auto;}
    }
	}
  .form{
    width: 100%;
    background-color: #D6F0FA;
    padding: 47px 0 111px 0;
    margin-bottom: 30px;
    // 表格
    .form_main{
      // height: 1000px;
      margin: 0 auto;
      padding: 64px 120px 66px 120px;
      box-sizing: border-box;
      background-color: #ffffff;
      // 表格标题
      p{
        color: #183075;
        letter-spacing: 2px;
        margin: 0 0 51px 0;
      }
      // 输入框
      .input_box{
        width: 100%;
        border: 1px solid #183075;
        border-radius: 10px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        margin-bottom: 43px;
        .options{
          width: 100%;
          border: none;
          /deep/ input {
            border: 0;
          }
        }
        div{
          color: #183075;
          letter-spacing: 2px;
          text-align: center;
          border-right: 1px solid #183075;
        }
        input{
          width: 100%;
          padding-left: 10px;
          box-sizing: border-box;
          border: none;
          outline: none;
        }
      }
      .confirm{
        width: 100%;
      }
      // 提交按钮
      .submit{
        background-color: #014099;
        color: #ffffff;
        letter-spacing: 2px;
        line-height: 2;
        text-align: center;
        border-radius: 10px;
        cursor: pointer;
        
      }
    }
  }
  /deep/ .form .form_main .input_box .options input {
    border: 0;
    font-size: 0.135417rem;

  }
  /deep/ .form .form_main .input_box input[data-v-e110066a] {
    width: 100%;
    font-size: 0.145833rem;
    padding-left: 0.08083rem !important;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: none;
    outline: none;
  }
/deep/ .el-input__inner{
    font-size: 0.145833rem !important;

}
/deep/ .el-select-dropdown__empty{
  font-size:  0.145833rem !important;
}

</style>



// WEBPACK FOOTER //
// src/view/join.vue